"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1224],{

/***/ 25233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ CardWithTitleAndDescription; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./components/sections/Cards/CardWithTitleAndDescription/cardWithTitleAndDescription.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 3rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xd61k20"
})("box-sizing:border-box;width:100%;max-width:35.5625rem;position:relative;display:flex;flex-direction:column;padding:3.5rem 2rem 2rem 2rem;background:#fff;border-radius:0.5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())));
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xd61k21"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:24px;font-weight:400;line-height:32px;letter-spacing:0em;text-align:left;color:#000000;border:solid 0.0625rem transparent;position:relative;&:before{content:' ';position:absolute;height:0.125rem;right:0;bottom:0;left:0;margin:-5px;border-radius:inherit;background:linear-gradient(89.99deg,#0e4ed7 -15.08%,#f94743 93.47%);}");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1xd61k22"
})("font-family:var(--font-second);font-size:16px;font-weight:300;line-height:32px;letter-spacing:0.20000000298023224px;text-align:left;color:#667070;");

;// CONCATENATED MODULE: ./components/sections/Cards/CardWithTitleAndDescription/CardWithTitleAndDescription.tsx




const CardWithTitleAndDescription = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                children: prismic_reactjs.RichText.asText(title)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                children: prismic_reactjs.RichText.asText(description)
            })
        ]
    });
};


/***/ }),

/***/ 11224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServiceTeam": function() { return /* binding */ ServiceTeam; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var consts_theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/sections/ServiceTeam/serviceTeam.style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 5.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 7.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 3rem;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    text-align: left;\n    font-weight: 400;\n    letter-spacing: -0.0125rem;\n    font-family: ",
        ";\n    margin: 0 0 2rem 0;\n\n    ",
        ";\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-bottom: 12.5rem;\n      justify-content: flex-start;\n      grid-template-columns: repeat(2, 23rem);\n      grid-template-rows: repeat(2, fit-content);\n    "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-bottom: 0;\n      position: relative;\n      grid-template-columns: repeat(2, 23rem);\n      grid-template-rows: repeat(2, fit-content);\n    "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    justify-content: center;\n    padding-bottom: 23.063rem;\n    gap: 2rem;\n    grid-template-rows: repeat(4, fit-content);\n\n    ",
        "\n\n    ",
        "\n  \n    > div {\n      max-width: 23rem;\n      padding: 0;\n    }\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: 50%;\n    transform: translate(0%, 50%);\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}




const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "erhuhsw0"
})(mixins/* defaultContainerSize */.sX, ";gap:3rem;position:relative;padding-top:4rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), " ", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())));
const SectionTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "erhuhsw1"
})((param)=>{
    let { theme  } = param;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), consts_theme/* THEME.font.questrial */.C.font.questrial, mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())));
});
const PositionsContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erhuhsw2"
})((param)=>{
    let { theme  } = param;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject6(), mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())));
});
const SectionImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erhuhsw3"
})("width:23.063rem;height:20.188rem;position:absolute;bottom:0;right:0;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";@media (min-width:1300px){transform:translate(-15%,50%);}");

// EXTERNAL MODULE: ./components/sections/Cards/CardWithTitleAndDescription/CardWithTitleAndDescription.tsx + 1 modules
var CardWithTitleAndDescription = __webpack_require__(25233);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/ServiceTeam/ServiceTeam.tsx






const ServiceTeam = (props)=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTitle, {
                as: props.titleAs,
                children: props.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PositionsContainer, {
                children: [
                    props.positions.map((position, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWithTitleAndDescription/* CardWithTitleAndDescription */.u, {
                            title: position.position,
                            description: position.description
                        }, index)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionImage, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            ...(0,imageSerializer/* imageSerializer */.l)(props.image)
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);